import { render, staticRenderFns } from "./AccountsCardDataModal.vue?vue&type=template&id=635e6b42&"
import script from "./AccountsCardDataModal.vue?vue&type=script&lang=js&"
export * from "./AccountsCardDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('635e6b42')) {
      api.createRecord('635e6b42', component.options)
    } else {
      api.reload('635e6b42', component.options)
    }
    module.hot.accept("./AccountsCardDataModal.vue?vue&type=template&id=635e6b42&", function () {
      api.rerender('635e6b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/AccountsCardDataModal.vue"
export default component.exports